import { StorageProvider } from "../storage-service/storage-service";
import { NewsProvider, PagerModel } from "./news";
import { SessionProvider } from "../session/session";
import { UserProvider } from "../user/user";
import { AnonymousSubject } from "rxjs";
import { GpsTracker } from "../../tracker/gps-tracker";
import { version } from "process";
import { AppVersion } from "@ionic-native/app-version";

export class NewsController {

    private static instance: NewsController;
    private readonly updateTime: number = 10000; // 10 sec

    storageService: StorageProvider = null;
    newsService: NewsProvider = null;
    sessionService: SessionProvider = null;
    userService: UserProvider = null;
    appVersion: AppVersion = null;

    appName: string = "";
    isAllowed: boolean = true;

    unreadNewsNumber: {
        newsGeneral,
        newsDHL
    } = {
            newsGeneral: 0,
            newsDHL: 0
        };

    news: {
        newsGeneral,
        newsDHL
    } = {
            newsGeneral: null,
            newsDHL: null
        };

    stored: {
        newsGeneral,
        newsDHL
    } = {
            newsGeneral: null,
            newsDHL: null
        };

    private constructor() { }

    setServices(storageService: StorageProvider, newsService: NewsProvider, sessionService: SessionProvider, userService: UserProvider, appName: string) {
        this.storageService = storageService;
        this.newsService = newsService;
        this.sessionService = sessionService;
        this.userService = userService;
        this.appName = appName;
    }

    public static getInstance(): NewsController {
        if (!NewsController.instance) {
            NewsController.instance = new NewsController();
        }

        return NewsController.instance;
    }

    check() {
        setInterval(() => {
            if (!GpsTracker.isRunning) {
                this.getNews().then(r => {
                    return r;
                });
            }
        }, this.updateTime);
    }

    // Promise<NewsRespond>
    // update:boolean indicates if we have new news either DHL or General ones.
    // type:string indicates the type of the news (DHL/General)
    // data: any indicates the array of news fetched 
    getNews(userMenu: boolean = false): Promise<NewsRespond> {
        return new Promise((resolve, reject) => {

            this.updateStatus().then((result) => {

                if (this.news.newsGeneral && this.stored.newsGeneral) {
                    this.unreadNewsNumber.newsGeneral = this.news.newsGeneral.length - this.stored.newsGeneral.length;
                    if (this.unreadNewsNumber.newsGeneral < 0) {
                        this.unreadNewsNumber.newsGeneral = this.news.newsGeneral.length;
                        this.storageService.saveData(this.news.newsGeneral, 'news-general');
                    }
                }
                else {
                    this.unreadNewsNumber.newsGeneral = (this.news.newsGeneral) ? this.news.newsGeneral.length : 0;
                }

                if (this.news.newsDHL && this.stored.newsDHL) {
                    this.unreadNewsNumber.newsDHL = this.news.newsDHL.length - this.stored.newsDHL.length;
                    if (this.unreadNewsNumber.newsDHL < 0) {
                        this.unreadNewsNumber.newsDHL = (this.news.newsDHL) ? this.news.newsDHL.length : 0;
                        this.storageService.saveData(this.news.newsDHL, 'news-dhl');
                    }
                }
                else {
                    this.unreadNewsNumber.newsDHL = (this.news.newsDHL) ? this.news.newsDHL.length : 0;
                }

                resolve(this.createResponde(userMenu));
            });

        });
    }

    // Prepare the interface object for resolve respond
    createResponde(userMenu: boolean = false) {
        let update = false;
        let type = "DHL";
        let data = null;
        let diff = this.unreadNewsNumber.newsGeneral - this.unreadNewsNumber.newsDHL;

        if (diff > 0) {
            type = "general";
            update = true;
            data = this.news.newsGeneral;

        } else if (diff < 0) {
            type = "DHL";
            update = true;
            data = this.news.newsDHL;
        } else if (diff == 0) {
            if (this.unreadNewsNumber.newsGeneral + this.unreadNewsNumber.newsDHL > 0)
                if (userMenu) {
                    type = "DHL";
                    update = true;
                    data = this.news.newsDHL;
                } else {
                    type = "general";
                    update = true;
                    data = this.news.newsGeneral;
                }
        }

        return { update: update, type: type, data: data };
    }

    //  Promise<boolean>
    //  false   - no DHL fetched
    //  true    - DHL news fetched
    updateStatus(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {

            //check if the user is logged in
            this.userService.checkLoged().then((logged) => {

                //fetch all general news from server + locally
                this.fetchGeneral().then(() => {

                    //check if the user is the member of Deutsche Post DHL Group

                    this.fetchDHL().then(() => {

                        resolve(true);
                    });
                });
            });

        });
    }

    fetchDHL(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {

            let savedSearch: PagerModel = {
                limit: '25',
                page: '1',
                start: '0'
            }
            // 171001

            let key = this.appName + '-news-dhl';

            Promise.all([this.newsService.getMyNews(savedSearch, 171001), this.storageService.checkForExistance(key)]).then(data => {


                this.news.newsDHL = data[0];

                //if the table exists
                if (data[1]) {
                    this.storageService.getSaved(key).then(stored => {


                        this.stored.newsDHL = stored;
                        resolve(null);
                    });
                } else {
                    resolve(null);
                }
            });

        });
    }

    fetchGeneral(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {

            let savedSearch: PagerModel = {
                limit: '25',
                page: '1',
                start: '0'
            }

            let key = this.appName + '-news-general';

            Promise.all([this.newsService.getMyNews(savedSearch), this.storageService.checkForExistance(key)]).then(data => {

                this.news.newsGeneral = data[0];

                //if the table exists
                if (data[1]) {
                    this.storageService.getSaved(key).then(stored => {

                        this.stored.newsGeneral = stored;
                        resolve(null);
                    });
                } else {
                    resolve(null);
                }
            });
        });
    }


}


export interface NewsRespond {
    update: boolean;
    type: string;
    data: any;
}


// WEBPACK FOOTER //
// /src/providers/news/news-contoller.ts